import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Button, TextField } from '@material-ui/core';
import moment from 'moment';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useStyles } from '../adminStyles';
import { fetchDefaultTimesheet } from '../../../redux/timesheets/timesheetsActions';
import { getManagersUsers } from '../../../redux/appUsers/appUserActions';
import { convertToDateString } from '../../../redux/utils/customMethods';
import { DB_DATE_FORMAT } from '../../../redux/constants';

import ExcelExport from './components/ExportExcel';
import DefaultersTable from './components/DefaultersTable';

const columns = [
  { id: 'name', label: 'Name' },
  { id: 'fromDate', label: 'From Date' },
  { id: 'toDate', label: 'To Date' },
  { id: 'status', label: 'Status' },
  { id: 'hours', label: 'Hours' },
];

const TimesheetDefaulters = props => {
  document.title = 'Sciata Defaulters';

  const {
    arrowIcons,
    weekSelectorContent,
    approveBtn,
    gridElLeft,
    gridElRight,
    inputMobile,
  } = useStyles();

  const dispatch = useDispatch();
  const users = useSelector(state => state.timesheets.defaulters);
  const currentUser = useSelector(state => state.users.currentUser);
  const managersUsers = useSelector(state => state.appUsers.managersUsers.body);

  const [orderAscending, setOrderAscending] = useState(true);
  const [asc, setAsc] = useState('desc');
  const [currentYear, setCurrentYear] = useState(moment().get('year'));
  const [searchTerm, setSearchTerm] = useState('');
  const [rows, setRows] = useState([]);

  const [userObj, setUserObj] = useState({});
  const [payPeriod, setPayPeriod] = useState({});
  const [week, setWeek] = useState({
    startDate: moment(moment().subtract(1, 'weeks').startOf('week')).format(
      DB_DATE_FORMAT
    ),
    endDate: moment(moment().subtract(1, 'weeks').endOf('week')).format(DB_DATE_FORMAT),
  });
  const [weekDays, setWeekDays] = useState([]);
  const [arrowClick, setArrowClick] = useState(0);
  const [render, setRender] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setRender(true);
    }, 500);
  }, []);

  const newRows = () => {
    let newArr = rows.map(user => {
      let firstName = user.name.split(' ')[0];
      let lastName = user.name.split(' ')[2];
      return { ...user, firstName: firstName, lastName: lastName };
    });
    return newArr;
  };

  useEffect(() => {
    if (render) {
      dispatch(
        fetchDefaultTimesheet({
          fromDate: `${week.startDate}`,
          toDate: `${week.endDate}`,
        })
      );
    }
  }, [render]);

  useEffect(() => {
    bindManagersUsers();
  }, []);

  const bindManagersUsers = () => dispatch(getManagersUsers(currentUser.id));

  useEffect(() => {
    if (arrowClick > 0) {
      dispatch(
        fetchDefaultTimesheet({
          fromDate: `${week.startDate}`,
          toDate: `${week.endDate}`,
        })
      );
    }
  }, [arrowClick]);

  useEffect(() => {
    let getDaysArray = (start, end) => {
      for (
        var arr = [], dt = new Date(start);
        dt <= new Date(end);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(new Date(dt));
      }
      return arr;
    };

    const daylist = getDaysArray(
      moment(`${week.startDate}`, DB_DATE_FORMAT),
      moment(`${week.endDate}`, DB_DATE_FORMAT)
    );
    const daysArr = daylist.map(day => moment(day).format('MM-DD-yyyy'));
    setWeekDays(daysArr);
  }, [week]);

  const rowData = {
    payPeriod: `${payPeriod.startDate}-${currentYear} - ${payPeriod.endDate}-${currentYear}`,
    timesheets: [],
  };

  // Need to finish the logic. Check needs to be for something more specific than firstName
  const getManagersUsersList = () => {
    let resultList = [];
    if (newRows && managersUsers) {
      managersUsers.map(managerUser => {
        newRows().map(newRowUser => {
          if (
            newRowUser.firstName === managerUser.firstName &&
            newRowUser.lastName === managerUser.lastName
          ) {
            resultList.push(newRowUser);
          }
        });
      });
    }
    return resultList;
  };

  useEffect(() => {
    users &&
      users.forEach(user => {
        if (user.status !== 'APPROVED') {
          rowData.timesheets.push({
            name: user.userName,
            fromDate: `${convertToDateString(user.fromDate, DB_DATE_FORMAT)}`,
            toDate: `${convertToDateString(user.toDate, DB_DATE_FORMAT)}`,
            status: user.status,
            hours: user.totalHours,
            empType: user.empType,
          });
        }
      });
  }, [users]);

  useEffect(() => {
    setRows(rowData.timesheets);
  }, [users]);

  const setTheSearchTerm = e => {
    setSearchTerm(e.target.value);
  };

  const sortArray = (arr, property) => () => {
    let array = [...arr];

    setOrderAscending(!orderAscending);

    orderAscending ? setAsc('asc') : setAsc('desc');
    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let nameA = a.name.toUpperCase();
          let nameB = b.name.toUpperCase();

          if (orderAscending) {
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          }
          if (!orderAscending) {
            if (nameB < nameA) {
              return -1;
            }
            if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
        })
      );
    }

    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const defaultersTableProps = {
    columns,
    rows: currentUser.role !== 'admin' ? getManagersUsersList() : rows,
    sortArray,
    orderAscending,
    asc,
    searchTerm,
    userObj,
  };

  return (
    <>
      <h1>Defaulters</h1>
      <Grid container justify='center' alignItems='center'>
        <Grid item xs={12} md={4} className={gridElLeft}>
          <TextField
            variant='outlined'
            className={inputMobile}
            type='search'
            label='Search'
            value={searchTerm}
            onChange={setTheSearchTerm}
          />
        </Grid>
        <Grid item xs={12} md={4} container direction='row' justify='center'>
          <Button
            onClick={() => {
              let _weekObj = {};
              _weekObj.startDate = moment(week.startDate, DB_DATE_FORMAT)
                .add(-7, 'day')
                .format(DB_DATE_FORMAT);
              _weekObj.endDate = moment(week.endDate, DB_DATE_FORMAT)
                .add(-7, 'day')
                .format(DB_DATE_FORMAT);
              setWeek(_weekObj);
              setArrowClick(arrowClick + 1);
            }}
          >
            <ArrowBackIosIcon className={arrowIcons} />
          </Button>
          <h2 className={weekSelectorContent}>{`${moment(
            week.startDate,
            DB_DATE_FORMAT
          ).format('MM/DD')} - ${moment(week.endDate, DB_DATE_FORMAT).format(
            'MM/DD'
          )}`}</h2>
          <Button
            onClick={() => {
              let _weekObj = {};
              _weekObj.startDate = moment(week.startDate, DB_DATE_FORMAT)
                .add(7, 'day')
                .format(DB_DATE_FORMAT);
              _weekObj.endDate = moment(week.endDate, DB_DATE_FORMAT)
                .add(7, 'day')
                .format(DB_DATE_FORMAT);
              setWeek(_weekObj);
              setArrowClick(arrowClick + 1);
            }}
          >
            <ArrowForwardIosIcon className={arrowIcons} />
          </Button>
        </Grid>
        <Grid item xs={12} md={4} className={gridElRight}>
          <ExcelExport approveBtn={approveBtn} {...defaultersTableProps} />
        </Grid>
        <Grid item xs={12}>
          <DefaultersTable {...defaultersTableProps} />
        </Grid>
      </Grid>
    </>
  );
};

export default TimesheetDefaulters;
